/**
 * Local replacement for @deere/scs-fetch that avoids the "Illegal invocation"
 * error caused by cross-fetch exporting an unbound window.fetch reference.
 * Behavior is identical to the original library.
 */
import { CRS_EXT_TOKEN, CRS_EXT_PARAM } from './constants';

const boundFetch = (() => {
     const root = typeof window !== 'undefined' ? window : globalThis;
     if (!root.fetch) {
         throw new Error('fetch is not available in this environment');
     }
     return root.fetch.bind(root);
 })();

const defaultHeaders = () => ({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
});

const defaultOptions = (fetchOptions) => {
    const options = fetchOptions;
    fetchOptions.redirect = options.redirect || 'manual';
    options.headers = { ...defaultHeaders(), ...options.headers };
    return options;
};

const isOtpTokenExpired = () => {
    try {
        const token = sessionStorage.getItem(CRS_EXT_TOKEN);
        if (!token) return false;
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        return !!(payload?.exp && Date.now() >= payload.exp * 1000);
    } catch {
        return false;
    }
};

const redirectToSurveyLogin = () => {
    const encryptedRn = sessionStorage.getItem(CRS_EXT_PARAM);
    sessionStorage.removeItem(CRS_EXT_TOKEN);
    const loginPath = encryptedRn
        ? `/surveyLogin?rn=${encodeURIComponent(encryptedRn)}`
        : '/surveyLogin';
    window.location.replace(loginPath);
};

export const fetch = async (url, fetchOptions = {}) => {
    const { rawResponse, ...rest } = fetchOptions;
    const options = defaultOptions(rest);

    if (isOtpTokenExpired()) {
        redirectToSurveyLogin();
        return new Promise(() => {});
    }

    const response = await boundFetch(url, options);
    if (!response.ok) {
        throw new Error(response.statusText);
    }

    if(rawResponse){
        return response;
    }

    if (response.status !== 204) {
        return response.json();
    }
};
